import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { acceptTermsAndConditions } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { AcceptTermsPayload } from "./types";
import providerOnboardingQueryKeys from "./query-keys";

interface AcceptTermsParams {
  userId: string;
  applicationId: string;
  providerType: string;
  payload: AcceptTermsPayload;
}

export const useAcceptTermsAndConditions = (
  options?: UseMutationOptions<unknown, Error, AcceptTermsParams>
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation<unknown, Error, AcceptTermsParams>({
    mutationFn: ({ userId, applicationId, providerType, payload }) =>
      acceptTermsAndConditions(userId, applicationId, providerType, payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: providerOnboardingQueryKeys.all });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
